export const ROUTES = {
  CHECKOUT_CUSTOMER_INFORMATION: '/checkout/information',
  CHECKOUT_PAYMENT_INFORMATION: '/checkout/payment',
  CHECKOUT_THANK_YOU: '/checkout/thank-you',
  CHECKOUT_ORDER_STATUS: '/checkout/order-status',
};

export const IS_CONTENT_PREVIEW_ENABLED =
  process.env.NEXT_PUBLIC_ENABLE_CONTENT_PREVIEW === 'true';

export const IS_DEV_ENV = process.env.NODE_ENV === 'development';

export const THEME_PREVIEW_ENVIRONMENT = 'theme_preview_environment';
export const THEME_PREVIEW_ENVIRONMENT_COOKIE_MAX_AGE = 60 * 30; // 30 min
